import { makeStyles } from '@material-ui/core/styles';

const selectedStyle = {
  backgroundColor: 'rgba(0,0,0,0.08)',
  color: 'rgba(0,0,0,0.7)',
};

export default makeStyles((theme) => ({
  root: {
    '&:focus > $content $label, &.Mui-selected:focus > $content $label, &.Mui-selected > $content $label, &.Mui-selected > $content $label:hover':
      {
        background: 'none',
      },
  },
  content: (props: { level: number; selected?: boolean }) => {
    const otherStyles = props.selected ? selectedStyle : {};

    return {
      paddingLeft: theme.spacing(2.25 * (props.level + 1)),
      width: 'auto',
      color: theme.palette.text.primary,
      height: '48px',
      '&:hover': {
        backgroundColor: theme.palette.grey[100],
      },
      ...otherStyles,
    };
  },
  iconContainer: {
    '& .MuiSvgIcon-root': {
      color: theme.palette.text.secondary,
      opacity: '60%',
    },
    '& > svg': {
      fontSize: '24px',
    },
  },
  label: {
    padding: `${theme.spacing(3)}px 0`,
    paddingLeft: theme.spacing(2),
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.body1.fontSize,
    '&:hover': {
      background: 'none',
    },
    '& .bolded-word': {
      fontWeight: theme.typography.fontWeightBold,
      color: 'rgba(0,0,0,0.8)',
      background: 'none',
    },
  },
  group: {
    margin: 0,
  },
}));
